import { render, staticRenderFns } from "./MotivosConsulta.vue?vue&type=template&id=8de74a64"
import script from "./MotivosConsulta.vue?vue&type=script&lang=js"
export * from "./MotivosConsulta.vue?vue&type=script&lang=js"
import style0 from "./MotivosConsulta.vue?vue&type=style&index=0&id=8de74a64&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports